export enum DashboardUser {
  USER_ID = "dashboard-user-id",
  USER_ORG_ID = "dashboard-user-org-id",
}
